module.exports = __webpack_public_path__ + "img/vynil.b910282c.svg";